
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',

    SET_INITIAL_DATA: 'set-data',
    CHECK_UPDATE_CHOICES: 'check-update-choices',
    CHECK_CHANGE: 'check-change',
    CHECK_SET_ERRORS: 'check-set-errors',
    CHECK_REMOVE_ERRORS: 'check-remove-errors',
    CHECK_REMOVE_FALSE: 'check-remove-false',
    CHECK_TOGGLE_DISABLE: 'check-toggle-disable',
};

const checkboxInputDataReducer = (state, action) => {
    //console.log("checkbox input dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }

        case ACTIONS.CHECK_UPDATE_CHOICES: {
            //console.log("state");
            //console.log(state);

            return {
                ...state,
                checkBoxes: action.options
            };
        }

        case ACTIONS.CHECK_TOGGLE_DISABLE:{
            //console.log("state");
            //console.log(state);
            //console.log(action.disabled);

            return {
                ...state,
                disabled: action.disabled,
                checkBoxes: 
                    state.checkBoxes.map((option) => {
                        //console.log(option);
                        if(action.disabled==true){
                            option.isChecked = false;
                        }
                        


                        //console.log(option);
                        return option;
                    }),  
                
            };
        }

        case ACTIONS.CHECK_CHANGE: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                checkBoxes: 
                    state.checkBoxes.map((option) => {
                        //console.log(option);
                        
                        if (option.name == action.name) {
                            //console.log("change");

                            if("checked" in action){
                                option.isChecked = action.checked;
                            }
                            if("value" in action){
                                option.value=action.value;
                            }
                            if("disabled" in action){
                                option.disabled = action.disabled;
                            }
                        }

                        //console.log(option);
                        return option;
                    }),  
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }

        case ACTIONS.CHECK_REMOVE_FALSE: {
            //console.log("remove_false");
            //console.log(state);

            return {
                ...state,
                checkBoxes: 
                    state.checkBoxes.filter((option) => 
                        option.isChecked != false
                    ),  
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }

        case ACTIONS.CHECK_REQUIRED_CHANGE: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    required: action.required
                }
            };
        }

        case ACTIONS.CHECK_SET_ERRORS: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors
                }
            };
        }
        case ACTIONS.CHECK_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }
    }
}



export {ACTIONS, checkboxInputDataReducer};